(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-content"] && !Shopify.designMode) return;
  try {
    
  
  function findAndLocateHeadings(){
    let ul = document.createElement("ul");
    ul.classList.add("navListStyle");
    
    let selected = document.querySelectorAll(document.getElementById("query").value);
    let headings = [];
    for(let el of selected){
      if(el.innerHTML !== "") headings.push(el);
    }

    if(headings.length > 0) {
      let counter = 1;
      headings.sort((a,b) => {return a.getBoundingClientRect().top - b.getBoundingClientRect().top});
      // headings.shift();
      for(let el of headings){
        let li = document.createElement("li");
        el.setAttribute("id", "ueberschrift-".concat(counter));
        const navBut = document.createElement("a");
        navBut.classList.add("singleNavButton");
        navBut.innerHTML = el.innerHTML.replaceAll(":", "");
        navBut.setAttribute("href", "#" + "ueberschrift-".concat(counter));
        counter++;
        li.appendChild(navBut);
        ul.appendChild(li);
      }
      if(document.getElementById("navContainer")) document.getElementById("navContainer").appendChild(ul);
    }
  }

  window.addEventListener('DOMContentLoaded', (event) => {
    if(document.getElementById("query") != null) findAndLocateHeadings();
  });


  } catch(e) { console.error(e); }
})();
})();
